import { render } from "./FilterAlcada.vue?vue&type=template&id=2886febc&scoped=true"
import script from "./FilterAlcada.vue?vue&type=script&lang=js"
export * from "./FilterAlcada.vue?vue&type=script&lang=js"

import "./FilterAlcada.vue?vue&type=style&index=0&id=2886febc&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2886febc"]])

export default __exports__